import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';

/**
 * Dropdown entry that opens the normal discussion list for the query.
 */
export default class SplitSearchSource {
  async search() {}

  view(query) {
    query = query.toLowerCase();

    return [
      <li className="Dropdown-header">{app.translator.trans('happydigital-split-search.forum.dropdown.heading')}</li>,
      <li className="SplitSearch-dropdownItem">
        <LinkButton icon="fas fa-search" href={app.route('index', { q: query })}>
          {app.translator.trans('happydigital-split-search.forum.dropdown.see_all', { query })}
        </LinkButton>
      </li>,
    ];
  }
}
